<template>
  <div class="configurar-push">
    <div class="my-3">
      <v-layout wrap>
        <v-flex xs12 md6>
          <div class="form-box">
            <p class="form-subtitle mb-2">
              {{ $t('campanhas.titulo') }}
            </p>
            <v-tooltip top :disabled="!disabled">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <input-with-best-offer
                    v-model="title"
                    height="60px"
                    channel="push"
                    field="title"
                    :offer-type="selectedOfferType"
                    :char-count="charCountByOfferType.title[selectedOfferType]"
                    :maxLength="maxLength.title"
                    :error="errors.title.length > 0"
                    :error-message="errors.title"
                  />
                </div>
              </template>
              <span>{{ disabledFieldTooltip }}</span>
            </v-tooltip>
            <p class="form-subtitle mt-9 mb-2">
              {{ $t('campanhas.texto_notificacao') }}
            </p>
            <v-tooltip top :disabled="!disabled">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <input-with-best-offer
                    v-model="text"
                    height="60px"
                    channel="push"
                    field="text"
                    :offer-type="selectedOfferType"
                    :char-count="charCountByOfferType.text[selectedOfferType]"
                    :maxLength="maxLength.text"
                    :error="errors.text.length > 0"
                    :error-message="errors.text"
                  />
                </div>
              </template>
              <span>{{ disabledFieldTooltip }}</span>
            </v-tooltip>

            <v-tooltip top :disabled="!disabled">
              <template v-slot:activator="{ on, attrs }">
                <div class="cursor-normal mt-9" v-bind="attrs" v-on="on">
                  <mf-toggle v-model="showImage" class="mf-toggle mb-4" hide-details :disabled="disabled" label="Imagem na notificação" />
                  <div v-if="showImage">
                    <mf-image-cropper
                      :mb-size-limit="0.3"
                      :upload-image="modifyBodyImg"
                      :error-message="errors.image_url.join(', ')"
                      :url="image_url"
                      :width="400"
                      :height="400"
                      show-hint
                      @remove-image="removeImage"
                      @snackbar="showSnackbar"
                    >
                      <template v-slot:hint-text> (Obs: Alguns dispositivos não exibem imagens push) </template>
                    </mf-image-cropper>
                  </div>
                </div>
              </template>
              <span>{{ disabledFieldTooltip }}</span>
            </v-tooltip>

            <p class="form-subtitle mb-n2">Notificação dentro do aplicativo</p>
            <v-tooltip top :disabled="!disabled">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <v-radio-group v-model="innerMessage" :disabled="disabled" row>
                    <v-radio key="inicial" label="Utilizar a mesma do push" color="primary" :value="false" />
                    <v-radio key="abrir" label="Escrever mensagem" color="primary" :value="true" />
                  </v-radio-group>
                </div>
              </template>
              <span>{{ disabledFieldTooltip }}</span>
            </v-tooltip>
          </div>
        </v-flex>
        <v-flex xs12 md6>
          <div class="ml-10 mb-n6 mt-12">
            <span class="mf-subtitle--cinza-0">Inspeção</span>
            <offer-type-options-menu :selected-offer-type.sync="selectedOfferType" :invalid-offer-types="invalidOfferTypes" :items="offerTypeOptions" />
          </div>
          <div class="outer-frame-push">
            <v-layout justify-center>
              <v-flex xs4>
                <v-layout>
                  <v-spacer />
                  <div class="camera-slot" />
                </v-layout>
              </v-flex>
              <v-flex xs4 class="ear-speaker-slot" />
              <v-flex xs4 />
            </v-layout>
            <div class="inner-frame-push">
              <div class="push-notification d-flex align-center justify-space-between">
                <div :style="image_url ? 'width: calc(100% - 75px)' : 'max-width: 100%'">
                  <div class="application-icon-slot" />
                  <span class="secondary-text push-application-name">{{ $t('campanhas.mercafacil') }}</span>
                  <push-preview :message="title" :offer-type="selectedOfferType" channel="push" field="title" />
                  <push-preview :message="text" :offer-type="selectedOfferType" channel="push" field="text" />
                </div>
                <img v-if="image_url" class="push-image" :src="image_url" />
              </div>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </div>

    <div v-if="innerMessage" class="my-3">
      <hr class="custom-hr" />
      <p class="ml-n6 inner-title">Notificação interna do aplicativo</p>
      <v-layout wrap>
        <v-flex xs12 md6>
          <div class="form-box">
            <p class="form-subtitle mb-2">{{ $t('campanhas.titulo') }}:</p>
            <input-with-best-offer
              v-model="inner_message_title"
              height="60px"
              channel="push"
              field="inner_message_title"
              :offer-type="selectedOfferType"
              :char-count="charCountByOfferType.inner_message_title[selectedOfferType]"
              :maxLength="maxLength.inner_message_title"
              :error="errors.inner_message_title.length > 0"
              :error-message="errors.inner_message_title"
            />
            <p class="form-subtitle mt-9 mb-2">{{ $t('campanhas.texto_mensagem') }}:</p>
            <input-with-best-offer
              v-model="inner_message_text"
              height="60px"
              channel="push"
              field="inner_message_text"
              :offer-type="selectedOfferType"
              :char-count="charCountByOfferType.inner_message_text[selectedOfferType]"
              :maxLength="maxLength.inner_message_text"
              :error="errors.inner_message_text.length > 0"
              :error-message="errors.inner_message_text"
            />
          </div>
        </v-flex>
        <v-flex xs12 md6>
          <div class="ml-10 mb-n6 mt-12">
            <span class="mf-subtitle--cinza-0">Inspeção</span>
            <offer-type-options-menu :selected-offer-type.sync="selectedOfferType" :invalid-offer-types="invalidOfferTypes" :items="offerTypeOptions" />
          </div>
          <div class="outer-frame-mensagem">
            <v-layout justify-center>
              <v-flex xs4>
                <v-layout>
                  <v-spacer />
                  <div class="camera-slot" />
                </v-layout>
              </v-flex>
              <v-flex xs4 class="ear-speaker-slot" />
              <v-flex xs4 />
            </v-layout>
            <div class="inner-frame-mensagem">
              <push-preview :message="inner_message_title" :offer-type="selectedOfferType" channel="push" field="inner_message_title" />
              <push-preview :message="inner_message_text" :offer-type="selectedOfferType" channel="push" field="inner_message_text" />
            </div>
            <v-layout justify-center>
              <div class="home-button" />
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { channelsForm } from '@/modules/maria/campanha-da-maria-v2/mixins/channels-form'
import { mariaCampaign } from '@/modules/maria/campanha-da-maria-v2/mixins/maria-campaign'
import { MUTATION_SINGLE_UPLOAD_BASE64 } from '@/graphql'
import { charCount } from '@/modules/maria/campanha-da-maria-v2/mixins/char-count'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { notOnlySpace } from '@/helpers/validators.js'
import { bestOfferValidations } from '@/modules/maria/campanha-da-maria-v2/mixins/best-offer-validations'

const CAMPAIGN_STATUS = {
  ACTIVE: 'ativa',
  FINISHED: 'concluída',
}

export default {
  name: 'PushConfiguration',

  components: {
    InputWithBestOffer: () => import('../InputWithBestOffer.vue'),
    OfferTypeOptionsMenu: () => import('../../OfferTypeOptionsMenu.vue'),
    PushPreview: () => import('./PushPreview.vue'),
  },

  mixins: [channelsForm, mariaCampaign, charCount, bestOfferValidations],
  emits: ['char-count', 'update:selected-offer-type'],

  data: () => ({
    title: '',
    text: '',
    inner_message_title: '',
    inner_message_text: '',
    image_url: '',
    disabled: false,
    showImage: false,
    innerMessage: false,
    errors: {
      title: [],
      text: [],
      inner_message_title: [],
      inner_message_text: [],
      image_url: [],
    },
    charCountByOfferType: {
      title: {},
      text: {},
      inner_message_title: {},
      inner_message_text: {},
    },
    maxLength: {
      title: 48,
      text: 100,
      inner_message_title: 48,
      inner_message_text: 100,
    },
  }),

  computed: {
    channelSettings() {
      return this.campaignSettings.channels.push || {}
    },
    disabledFieldTooltip() {
      const status = this.isMariaCampaignFinished ? CAMPAIGN_STATUS.FINISHED : CAMPAIGN_STATUS.ACTIVE
      return `Não é possível alterar essa configuração em uma campanha ${status}.`
    },
    invalidOfferTypes() {
      const invalidOfferTypes = []

      this.offerTypeOptions.forEach((option) => {
        const textCharCount = this.charCountByOfferType.text[option.value]
        const titleCharCount = this.charCountByOfferType.title[option.value]

        if (this.innerMessage) {
          const innerMessageTitleCharCount = this.charCountByOfferType.inner_message_title[option.value]
          const innerMessageTextCharCount = this.charCountByOfferType.inner_message_text[option.value]

          if (innerMessageTitleCharCount > this.maxLength.inner_message_title || innerMessageTextCharCount > this.maxLength.inner_message_text) {
            invalidOfferTypes.push(option.value)
          }
        }

        if (textCharCount > this.maxLength.text || titleCharCount > this.maxLength.title) {
          invalidOfferTypes.push(option.value)
        }
      })

      return invalidOfferTypes
    },
  },

  watch: {
    innerMessage(value) {
      if (!value) {
        this.resetInnerMessage()
      }
    },
    title() {
      this.clearInputErrorMessage('title')
      this.countCharacters('title')
    },
    text() {
      this.clearInputErrorMessage('text')
      this.countCharacters('text')
    },
    inner_message_title() {
      this.clearInputErrorMessage('inner_message_title')
      this.countCharacters('inner_message_title')
    },
    inner_message_text() {
      this.clearInputErrorMessage('inner_message_text')
      this.countCharacters('inner_message_text')
    },
    image_url(value) {
      if (value) this.errors.image_url = []
    },
    showImage(newVal) {
      if (!newVal) this.removeImage()
    },
    selectedOfferType: {
      immediate: true,
      handler(newVal) {
        this.$emit('update:selected-offer-type', newVal)
      },
    },
  },

  mounted() {
    this.initializeFromChannelSettings()
    this.createCharCount()
    this.countAllCharacters()
  },

  methods: {
    initializeFromChannelSettings() {
      const { message } = this.channelSettings
      if (!message) return

      this.title = message.title || ''
      this.text = message.text || ''
      this.inner_message_title = message.inner_message_title || ''
      this.inner_message_text = message.inner_message_text || ''
      this.image_url = message.image_url || ''
      this.showImage = !!this.image_url

      if (this.inner_message_title || this.inner_message_text) {
        this.innerMessage = true
      }
    },
    createCharCount() {
      const charCountByOfferType = {}

      Object.keys(this.charCountByOfferType).forEach((field) => {
        charCountByOfferType[field] = {}
        this.offerTypeOptions.forEach((option) => {
          charCountByOfferType[field][option.value] = 0
        })
      })
      this.$set(this, 'charCountByOfferType', charCountByOfferType)
    },
    countAllCharacters() {
      Object.keys(this.charCountByOfferType).forEach((field) => {
        this.countCharacters(field)
      })
    },
    countCharacters(field) {
      this.offerTypeOptions.forEach((option) => {
        this.charCountByOfferType[field][option.value] = this.countTextWithVariables(this[field], 'push', field, option.value)
      })
    },
    resetInnerMessage() {
      this.inner_message_title = ''
      this.inner_message_text = ''
    },
    async modifyBodyImg({ base64, filename }) {
      try {
        const { data } = await this.$apollo.mutate({
          mutation: MUTATION_SINGLE_UPLOAD_BASE64,
          variables: { filename, base64 },
          context: { uri: this.$microservicesUrls['upload'] },
        })

        this.image_url = data.singleUploadBase64.url
      } catch (error) {
        console.error('Error uploading image:', error)
        this.$snackbar({
          message: 'Erro ao fazer upload da imagem. Por favor, tente novamente.',
          color: 'error',
        })
      }
    },
    removeImage() {
      if (this.disabled) return
      this.image_url = ''
    },
    showSnackbar(snackbar) {
      this.$snackbar(snackbar)
    },
    selectTemplate(template) {
      this.title = template.message
      this.text = template.message
    },
    clearInputErrorMessage(attr) {
      if (attr) {
        this.errors[attr] = []
        return
      }
      this.errors = {
        title: [],
        text: [],
        inner_message_title: [],
        inner_message_text: [],
        image_url: [],
      }
    },
    validInput(attr) {
      this.clearInputErrorMessage(attr)

      const validateCharLimit = (field, count, maxLength, option) => {
        if (count > maxLength) {
          this.errors[field].push(`A mensagem ultrapassa o limite de ${maxLength} caracteres para ${option.text}.`)
        }
      }

      this.offerTypeOptions.forEach((option) => {
        validateCharLimit('text', this.charCountByOfferType.text[option.value], this.maxLength.text, option)
        validateCharLimit('title', this.charCountByOfferType.title[option.value], this.maxLength.title, option)

        if (this.innerMessage) {
          validateCharLimit('inner_message_title', this.charCountByOfferType.inner_message_title[option.value], this.maxLength.inner_message_title, option)
          validateCharLimit('inner_message_text', this.charCountByOfferType.inner_message_text[option.value], this.maxLength.inner_message_text, option)
        }
      })

      const validateBestOffers = (field, value) => {
        if (this.hasMoreThanOneBestOffer(value)) {
          this.errors[field].push(`A mensagem não pode conter mais de uma variável de melhor oferta.`)
        }
        if (this.hasInvalidBestOffer(value)) {
          this.errors[field].push(`A mensagem contém uma variável de melhor oferta inválida.`)
        }
      }

      this.errors.text.push(...this.validateVariables(this.text))
      this.errors.title.push(...this.validateVariables(this.title))

      validateBestOffers('text', this.text)
      validateBestOffers('title', this.title, 'título')

      if (this.innerMessage) {
        this.errors.inner_message_title.push(...this.validateVariables(this.inner_message_title))
        this.errors.inner_message_text.push(...this.validateVariables(this.inner_message_text))
        validateBestOffers('inner_message_title', this.inner_message_title, 'título')
        validateBestOffers('inner_message_text', this.inner_message_text)
      }

      const validateField = (field, validations) => {
        Object.entries(validations).forEach(([validation, message]) => {
          if (!this.$v[field]?.[validation]) {
            this.errors[field].push(message)
          }
        })
      }

      validateField('title', {
        required: 'Insira um título para esta notificação.',
        notOnlySpace: 'Não é permitido salvar apenas espaços.',
      })

      validateField('text', {
        notOnlySpace: 'Não é permitido salvar apenas espaços.',
      })

      if (this.innerMessage) {
        validateField('inner_message_title', {
          required: 'Insira um título para esta notificação.',
          notOnlySpace: 'Não é permitido salvar apenas espaços.',
        })

        validateField('inner_message_text', {
          notOnlySpace: 'Não é permitido salvar apenas espaços.',
        })
      }

      if (this.showImage && !this.image_url) {
        this.showImage = false
      }

      const validateProductsAndPrices = (field, message) => {
        if (!this.hasEnoughProducts(message)) {
          this.errors[field].push(
            'Para utilizar essa quantidade de produtos na variável de melhor oferta, você precisa ter pelo menos essa quantidade de produtos no passo 2. Por favor volte e insira os produtos faltantes.'
          )
        }

        if (!this.isPricesCorrect('push', field, 'offer_sales', message)) {
          this.errors[field].push(
            'Para utilizar as subvariáveis de preço você precisa configurar seus respectivos valores no passo 2. Por favor volte e preencha os campos deixados em branco ou remova os preços das suas mensagens.'
          )
        }
      }

      validateProductsAndPrices('title', this.title)
      validateProductsAndPrices('text', this.text)

      if (this.innerMessage) {
        validateProductsAndPrices('inner_message_title', this.inner_message_title)
        validateProductsAndPrices('inner_message_text', this.inner_message_text)
      }

      return Object.values(this.errors).every((error) => error.length === 0)
    },
    getChannelData() {
      return {
        ...this.channelSettings,
        message: {
          title: this.title,
          text: this.text,
          inner_message_title: this.inner_message_title,
          inner_message_text: this.inner_message_text,
          inner_amount_best_offers_title: null,
          inner_amount_best_offers: null,
          amount_best_offers_title: null,
          amount_best_offers: null,
          action: null,
          image_url: this.image_url,
        },
      }
    },
  },
  validations() {
    return {
      title: {
        required,
        notOnlySpace,
      },
      text: {
        notOnlySpace,
      },
      inner_message_title: {
        required: requiredIf(function () {
          return this.innerMessage
        }),
        notOnlySpace,
      },
      inner_message_text: {
        notOnlySpace,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
$phone-size: 600px;
$tablet-size: 960px;

.configurar-push {
  p,
  span {
    max-width: inherit;
    max-height: inherit;
    word-wrap: break-word;
  }
  .outer-frame-push {
    border: 2px solid $cinza-l80;
    border-radius: 40px 40px 0 0;
    border-bottom: 0;
    @media screen and (max-width: $tablet-size) {
      padding: 4vh 3vw;
      margin: 5vh 3vw;
    }
    @media screen and (min-width: $tablet-size) {
      margin: 5vh 3vw 0;
      padding: 4vh 3vw 0;
    }
    height: 48vh;
    .camera-slot {
      border: 2px solid $cinza-l80;
      border-radius: 20px;
      display: inline-block;
      margin-bottom: 5vh;
      height: 2vh;
      width: 2vh;
      margin-right: 0.8vw;
    }
    .ear-speaker-slot {
      border: 2px solid $cinza-l80;
      border-radius: 30px;
      display: inline-block;
      margin-bottom: 5vh;
      height: 2vh;
      width: 10vw;
      margin-left: 0.8vw;
    }
    .inner-frame-push {
      border: 2px solid $cinza-l80;
      border-bottom: 0;
      height: 36vh;
      max-height: 36vh;
      overflow-y: auto;
      .push-notification {
        background-color: $cinza-l90;
        padding: 1.6vw;
        .application-icon-slot {
          background-color: $branco;
          width: 0.8vw;
          height: 0.8vw;
          display: inline-block;
          border-radius: 2px;
        }
        .push-application-name {
          padding-left: 0.8vw;
          font-size: 10px;
          display: inline-block;
        }
      }
    }
  }
  .outer-frame-mensagem {
    border: 2px solid $cinza-l80;
    border-radius: 40px;
    height: 80vh;
    padding: 4vh 4vw;
    margin: 3vw;
    .camera-slot {
      border: 2px solid $cinza-l80;
      border-radius: 20px;
      display: inline-block;
      margin-bottom: 3vh;
      height: 2vh;
      width: 2vh;
      margin-right: 0.8vw;
    }
    .ear-speaker-slot {
      border: 2px solid $cinza-l80;
      border-radius: 30px;
      display: inline-block;
      margin-bottom: 3vh;
      height: 2vh;
      width: 10vw;
      margin-left: 0.8vw;
    }
    .inner-frame-mensagem {
      border: 2px solid $cinza-l80;
      height: 60vh;
      max-height: 60vh;
      overflow-y: auto;
      padding: 2vw;
    }
    .home-button {
      border: 2px solid $cinza-l80;
      border-radius: 40px;
      margin-top: 2vh;
      height: 6vh;
      width: 6vh;
    }
  }
  .mf-subtitle--cinza-0 {
    font-family: Lato;
    font-weight: 700;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: 0.4px;
    color: $cinza-0;
  }
  .custom-hr {
    border: none;
    background-color: $cinza-l60;
    height: 1px;
    margin: 24px -24px;
  }
  .inner-title {
    font-family: Lato;
    font-weight: 700;
    font-size: 20px;
    line-height: 120%;
    letter-spacing: 0%;
    color: $cinza-d10;
  }
  .form-subtitle {
    font-family: Lato;
    font-weight: 700;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: 0.4px;
    color: $cinza-d10;
  }
}

.form-box {
  padding: 30px 20px 35px 0px;
  border-radius: 4px;
}
.v-application--is-ltr .v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
  margin-right: 2px;
  margin-top: 5px !important;
}
.v-application--is-ltr .v-textarea.v-text-field--enclosed .v-text-field__slot {
  margin-bottom: 5px;
}

.variable-highlight {
  color: $marca-1;
}

.variable-error {
  color: #d83e3e !important;
}

.variable-error-super {
  .variable-highlight {
    color: $marca-1 !important;
  }
  color: #d83e3e !important;
}

.mf-toggle {
  label {
    color: $cinza-d10 !important;
    font-weight: 700;
    font-size: 16px !important;
    line-height: 1;
  }
}

.cursor-normal {
  cursor: initial !important;
}

.disabled {
  color: $cinza-d10;
}

.push-image {
  width: 60px;
  height: 60px;
}
</style>
